/* COB LED V5 — FAZ07-I8.1 TECHNICAL TRUTH + COMPARISON FOUNDATION · DYN324-R7.5 BASE */
/* R4 — comparison decision integrity owner. Comparison-only; no scoring/ranking service mutation. */
window.GDX_COB_V5_R4_COMPARISON_INTEGRITY_CONTRACT=Object.freeze({
  version:'COB-V5-R4-COMPARISON-DECISION-INTEGRITY-V2.2',
  scope:'ALL_COMPARISON_SELECTABLE_OFFERS_ALL_PURPOSES_BOTH_LANES',
  sameLaneRankOwner:'R3.1_RECOMMENDER_COMPARATOR',
  crossLanePolicy:'SELECTION_ORDER_PRESERVED_NO_COMMON_RANK_WINNER',
  nonAdmissibleSameLanePolicy:'SELECTION_ORDER_PRESERVED_NO_COMMON_RANK_WINNER',
  fp14PublicPrecision:0,
  fp14MeaningfulDeltaMin:1,
  productAllowlist:false,
  purposeAllowlist:false,
  specialCaseCount:0,
  scoringMutation:'NONE',
  rankingMutation:'NONE',
  setupTruthMutation:'NONE',
  commerceMutation:'NONE',
  panelMutation:'NONE'
});
(()=>{
  "use strict";
  /* COB-V5-U7D-C1-ADMISSION-CUSTOMER-COPY-V1\n     Customer-facing admission labels only; internal R4S states remain unchanged. */
  /* COB-V5-U7A-CUSTOMER-PACKAGE-MANUAL-DEFAULT-V1
     Customer package-display policy only: every offer displays exactly one
     "Kullanım kılavuzu" item. Canonical catalog/evidence truth is not mutated. */
  const app=window.GDX_COB_LED_V5;
  !app||!app.runtime||app.runtime.has("productExperience")||app.runtime.register("productExperience", ({
    services, events, diagnostics
  }
  )=>{
    const state={
      compareKeys:[], lastPool:null, listeners:[]
    }
    , LANE_LABELS=Object.freeze({
      BARE_LIGHT:"Yaln\u0131z \u0131\u015F\u0131k \xFCnitesi", SINGLE_READY_SET:"Tek \u0131\u015F\u0131kl\u0131 haz\u0131r set"
    }
    ), FIELD_LABELS=Object.freeze({
      powerW:"G\xFC\xE7", photometricOutput:"Ayd\u0131nl\u0131k d\xFCzeyi / Lux", colorFamily:"Renk ailesi", cctMinK:"En d\xFC\u015F\xFCk CCT", cctMaxK:"En y\xFCksek CCT", cri:"CRI", tlci:"TLCI", mountType:"Ba\u011Flant\u0131", fxModeCount:"FX modlar\u0131", warrantyYears:"Garanti", dmx:"DMX", bluetooth:"Bluetooth", appControl:"Uygulama kontrol\xFC", remote2_4g:"2.4G kumanda", batterySupport:"Batarya deste\u011Fi", batteryMode:"Batarya yap\u0131s\u0131", batteryCapacityMah:"Batarya kapasitesi", cooling:"So\u011Futma sistemi", quietCapability:"Sessiz \xE7al\u0131\u015Fma modu", flickerFree:"Anti-Flicker (Titre\u015Fimsiz)"
    }
    );
    function fold(value2){
      return String(value2??"").normalize("NFKC").toLocaleUpperCase("tr-TR").replace(/İ/g, "I").replace(/Ş/g, "S").replace(/Ğ/g, "G").replace(/Ü/g, "U").replace(/Ö/g, "O").replace(/Ç/g, "C").replace(/\s+/g, " ").trim()
    }
    function value(record){
      return record&&record.value!==void 0?record.value:null
    }
    function known(record){
      return record&&record.value!==null&&record.value!==void 0&&record.status!=="UNKNOWN"&&record.status!=="CONTRADICTED"
    }
    function formatBoolean(v){
      return v===!0?"Var":v===!1?"Yok":"Bilinmiyor"
    }
    function colorLabel(v){
      return v==="FULL_COLOR_RGB"?"Full-color RGB":v==="BICOLOR"?"Bi-Color":v||"Bilinmiyor"
    }
    function laneLabel(v){
      return LANE_LABELS[v]||"Bilinmeyen kulvar"
    }
    function scoreByOffer(){
      return new Map((services.scoring.getEvaluation()?.offers||[]).map(row=>[row.offerKey, row]))
    }
    function r4sShadowByOffer(){
      return new Map((services.scoring.getShadowEvaluation?.()?.offers||[]).map(row=>[row.offerKey,row]))
    }
    function r4sPurposeResult(shadowRow,purposeKey){
      return (shadowRow?.purposes||[]).find(row=>row.purposeKey===purposeKey)||null
    }
    function catalogOffer(key){
      return services.catalog.getOffer(key)
    }
    function imageList(offer){
      return Array.isArray(value(offer?.images))?value(offer.images).filter(x=>x&&x.src).slice(0, services.config.budgets.maxImagesPerOffer):[]
    }
    const MODIFIER_TYPE_LABELS=Object.freeze({
      RECTANGULAR_SOFTBOX:"Dikd\xF6rtgen softbox", OCTAGON_OR_PARABOLIC:"Oktagonal veya parabolik softbox", STRIP_SOFTBOX:"Strip softbox", UMBRELLA:"\u015Eemsiye", REFLECTOR:"Tas reflekt\xF6r"
    }
    );
    function modifierTypeLabel(rawValue){
      const raw=String(rawValue||"").trim();
      if(!raw)return"I\u015F\u0131k \u015Fekillendirici";
      const key=fold(raw).replace(/\s+/g, "_");
      if(MODIFIER_TYPE_LABELS[key])return MODIFIER_TYPE_LABELS[key];
      if(!raw.includes("_"))return raw;
      const humanized=raw.replace(/_+/g, " ").toLocaleLowerCase("tr-TR");
      return humanized.charAt(0).toLocaleUpperCase("tr-TR")+humanized.slice(1)
    }
    function packageItems(offer){
      const pkg=offer?.package||{
      }
      , rows=["I\u015F\u0131k \xFCnitesi"], specificModifierKnown=known(pkg.softboxIncluded)||known(pkg.umbrellaIncluded)||known(pkg.reflectorIncluded);
      if(value(pkg.softboxIncluded)===!0){
        let text=modifierTypeLabel(value(pkg.modifierType));
        /softbox/i.test(text)||(text="Softbox");
        const w=value(pkg.modifierWidthCm), h=value(pkg.modifierHeightCm), d=value(pkg.modifierDiameterCm);
        w&&h?text+=` ${w}\xD7${h} cm`:d&&(text+=` ${d} cm`), rows.push(text)
      }
      if(value(pkg.umbrellaIncluded)===!0&&rows.push("\u015Eemsiye"), value(pkg.reflectorIncluded)===!0&&rows.push("Tas reflekt\xF6r"), !specificModifierKnown&&value(pkg.modifierIncluded)===!0){
        let text=modifierTypeLabel(value(pkg.modifierType));
        const w=value(pkg.modifierWidthCm), h=value(pkg.modifierHeightCm), d=value(pkg.modifierDiameterCm);
        w&&h?text+=` ${w}\xD7${h} cm`:d&&(text+=` ${d} cm`), rows.push(text)
      }
      if(value(pkg.standIncluded)===!0&&rows.push(value(pkg.standHeightCm)?`I\u015F\u0131k aya\u011F\u0131 (${value(pkg.standHeightCm)} cm)`:"I\u015F\u0131k aya\u011F\u0131"), value(pkg.gridIncluded)===!0&&rows.push("Grid"), value(pkg.mountAdapterIncluded)===!0&&rows.push("Mini Bowens\u2013Bowens adapt\xF6r\xFC"), value(pkg.powerCableIncluded)===!0&&rows.push("G\xFC\xE7 kablosu"), value(pkg.protectiveCapIncluded)===!0&&rows.push("COB koruyucu kapak"), value(pkg.manualIncluded)===!0&&rows.push("Kullan\u0131m k\u0131lavuzu"), value(pkg.remoteIncluded)===!0){
        const remote24=value(offer?.technical?.controls?.remote2_4g)===!0;
        rows.push(remote24?"2.4G kablosuz kumanda":"Uzaktan kumanda")
      }
      value(pkg.bagIncluded)===!0&&rows.push("Ta\u015F\u0131ma \xE7antas\u0131");
      value(pkg.batteryIncluded)===!0&&rows.push("Harici batarya");
      value(pkg.chargerIncluded)===!0&&rows.push("\u015Earj cihaz\u0131");

      /* U7A customer package-display default.
         If source truth already contains the manual, keep it once.
         If source truth does not expose it, add the same plain customer label.
         No evidence/status/explanation is attached to the label. */
      rows.includes("Kullan\u0131m k\u0131lavuzu")||rows.push("Kullan\u0131m k\u0131lavuzu");

      return [...new Set(rows)]
    }
    function recordDisplay(record, fallback=null){
      return record?String(record.displayValue??value(record)??fallback??""):fallback
    }
    function mountLabel(record){
      const raw=recordDisplay(record, "Bilinmiyor");
      return{
        BOWENS:"Bowens", MINI_BOWENS:"Mini Bowens"
      }
      [raw]||raw
    }
    function batteryModeLabel(record){
      const raw=value(record);
      return record?.displayValue?record.displayValue:raw==="INTERNAL"?"Dahili batarya":raw==="EXTERNAL_INCLUDED"?"Harici batarya pakette dahil":raw==="EXTERNAL_OPTIONAL"?"Harici batarya destekli":String(raw||"Bilinmiyor")
    }
    function coolingLabel(typeRecord, rpmRecord, quietRecord){
      const type=value(typeRecord), quiet=value(quietRecord)===!0;
      if(type==="ACTIVE_FAN"){
        const metadataQuiet=typeRecord?.quietFanClaim===!0||/sessiz/i.test(String(typeRecord?.displayValue||"")), base=quiet||metadataQuiet?"Sessiz fan":"Fanl\u0131 so\u011Futma";
        return known(rpmRecord)?`${base} (${value(rpmRecord)} rpm)`:base
      }
      return type==="PASSIVE"?"Fans\u0131z so\u011Futma":recordDisplay(typeRecord, "Bilinmiyor")
    }
    const NUMBER_TR=new Intl.NumberFormat("tr-TR", {
      maximumFractionDigits:0
    }
    );
    /* COB-V5-U7D-C2-PHOTOMETRIC-CUSTOMER-COPY-V1
       PRESENTATION ONLY:
       - comparison unknown display -> "Belirtilmemiş"
       - non-positive/unknown CCT is omitted, never shown as 0 K
       - "ölçüm konfigürasyonu" -> "Ölçüm koşulu"
       - "puan dışı" -> "yalnız bilgi amaçlı"
       Raw evidence/scoring rows remain unchanged. */
    function photometricModifierLabel(raw){
      const value2=String(raw||"").trim();
      if(!value2||value2==="UNSPECIFIED")return"";
      return{
        BARE:"çıplak COB", STANDARD_REFLECTOR:"standart reflektör", BR30A_REFLECTOR:"BR30A reflektör", MANUFACTURER_STANDARD_CONFIGURATION:"üretici standart konfigürasyonu"
      }
      [value2]||value2.replace(/_/g, " ").toLocaleLowerCase("tr-TR")
    }
    function photometricRow(offer){
      const family=value(offer?.headFamilyKey), luxRows=services.evidence.getLuxRows(family);
      if(!luxRows.length)return null;

      /* FAZ09.6.3 — UI presentation only.
         Raw registry rows stay untouched for scoring/evidence.
         Customer UI groups identical measurement conditions instead of dumping every CCT row. */
      const groups=new Map;
      luxRows.forEach(row=>{
        const distance=Number.isFinite(row.distanceM)?Number(row.distanceM):null;
        const modifier=photometricModifierLabel(row.modifierOrReflector)||"Ölçüm koşulu";
        const scoreClass=row.scoreUse==="MATCHED_GROUP_ONLY"?"MATCHED":"NON_SCOREABLE";
        const key=`${distance??"?"}|${modifier}|${scoreClass}`;
        const group=groups.get(key)||{distance,modifier,scoreClass,rows:[]};
        group.rows.push(row);
        groups.set(key,group)
      });

      const values=[...groups.values()].map(group=>{
        const luxValues=group.rows.map(row=>Number(row.lux)).filter(Number.isFinite).sort((a,b)=>a-b);
        const cctValues=group.rows
          .map(row=>Number(row.cctK))
          .filter(v=>Number.isFinite(v)&&v>0)
          .sort((a,b)=>a-b);
        if(!luxValues.length)return"";

        const luxMin=luxValues[0],luxMax=luxValues[luxValues.length-1];
        const luxText=luxMin===luxMax?NUMBER_TR.format(luxMin):`${NUMBER_TR.format(luxMin)}–${NUMBER_TR.format(luxMax)}`;
        const distanceText=Number.isFinite(group.distance)?` @ ${group.distance} m`:"";
        let cctText="";
        if(cctValues.length){
          const cctMin=cctValues[0],cctMax=cctValues[cctValues.length-1];
          cctText=` · ${cctMin===cctMax?`${cctMin} K`:`${cctMin}–${cctMax} K`}`
        }
        const treatment=group.scoreClass==="MATCHED"?"değerlendirmeye dahil":"yalnız bilgi amaçlı";
        return`${group.modifier}: ${luxText} Lux${distanceText}${cctText} · ${treatment}`
      }).filter(Boolean);

      return Object.freeze({
        key:"photometricOutput",
        labelTr:FIELD_LABELS.photometricOutput,
        valueTr:values.join(" | "),
        sourceStatus:luxRows.length===1?luxRows[0].evidenceStatus:"MULTI_SOURCE_PHOTOMETRIC",
        confidence:luxRows.reduce((sum,row)=>sum+(Number(row.confidence)||0),0)/luxRows.length,
        scoreUse:luxRows.every(row=>row.scoreUse==="MATCHED_GROUP_ONLY")?"MATCHED_GROUP_ONLY":"NOT_SCOREABLE_OR_MIXED",
        rawPhotometricRowCount:luxRows.length,
        presentationGroupCount:values.length
      })
    }
    function evidenceSummary(purpose, technical){
      const hasLux=technical.some(row=>row.key==="photometricOutput"), luxCopy=hasLux?" Fotometrik değerler yalnız ölçüm koşulları eşleştiğinde skora katılır; diğer Lux kayıtları bilgi amaçlı ve puan dışı gösterilir.":"";
      if(!purpose)return`Genel teknik ve paket verileri doğrulanmış kaynaklardan gösteriliyor; kaynağı bulunmayan alanlar bilinmiyor olarak bırakılır.${luxCopy}`;
      const base=purpose.confidence>=.8&&purpose.coverage>=.75?"Seçili amaç için temel teknik ve paket verileri yüksek güvenle doğrulandı.":"Seçili amaç değerlendirmesi doğrulanmış alanlarla oluşturuldu; eksik alanlar puanlamaya zorla eklenmedi.";
      return`${base}${luxCopy}`
    }
    function canonicalHeadEvidenceRecord(offer, field, liveRecord){
      /* I9: canonical live catalog truth is the primary owner.
         Static manufacturer evidence may only fill a genuinely missing live field. */
      if(known(liveRecord))return liveRecord;
      const family=value(offer?.headFamilyKey), evidence=services.evidence?.getField?.(family, field);
      if(!evidence||evidence.value===null||evidence.value===void 0||evidence.sourceStatus!=="EXPLICIT_MANUFACTURER"||String(evidence.scoreUse||"").startsWith("EXCLUDED"))return liveRecord;
      return Object.freeze({
        value:evidence.value, status:"STATIC_EVIDENCE", sourceType:evidence.sourceStatus, sourceRef:evidence.sourceId||"", confidence:Number(evidence.confidence)||0, displayValue:evidence.displayValue??String(evidence.value), scoreUse:evidence.scoreUse||"ALLOWED"
      })
    }
    function technicalRows(offer){
      const t=offer?.technical||{
      }
      , controls=t.controls||{
      }
      , powerOptions=t.powerOptions||{
      }
      , powerRecord=t.perHeadWatt||t.powerW||null, rows=[], push=(key, text, record)=>{
        known(record)&&rows.push(Object.freeze({
          key, labelTr:FIELD_LABELS[key], valueTr:text, sourceStatus:record.status, confidence:record.confidence??0
        }
        ))
      }
      ;
      push("powerW", `${value(powerRecord)} W`, powerRecord), (()=>{
        const photometric=photometricRow(offer);
        photometric&&rows.push(photometric)
      }
      )(), push("colorFamily", colorLabel(value(t.colorFamily)), t.colorFamily), (known(t.cctMinK)||known(t.cctMaxK))&&rows.push(Object.freeze({
        key:"cctRange", labelTr:"CCT aral\u0131\u011F\u0131", valueTr:`${known(t.cctMinK)?value(t.cctMinK):"?"}\u2013${known(t.cctMaxK)?value(t.cctMaxK):"?"} K`, sourceStatus:known(t.cctMinK)&&known(t.cctMaxK)?"EXPLICIT_OR_RESOLVED":"PARTIAL", confidence:Math.min(t.cctMinK?.confidence||0, t.cctMaxK?.confidence||0)
      }
      )), push("cri", recordDisplay(t.cri), t.cri), (()=>{const record=canonicalHeadEvidenceRecord(offer, "tlci", t.tlci);push("tlci", recordDisplay(record), record)})(), push("mountType", mountLabel(t.mountType), t.mountType), (()=>{const record=canonicalHeadEvidenceRecord(offer, "fxModeCount", t.fxModeCount);push("fxModeCount", `${value(record)} efekt`, record)})(), push("warrantyYears", `${value(offer.warrantyYears)} yıl`, offer.warrantyYears);
      for(const key of["dmx", "bluetooth", "appControl", "remote2_4g"])push(key, formatBoolean(value(controls[key])), controls[key]);
      return push("batterySupport", formatBoolean(value(powerOptions.batterySupport)), powerOptions.batterySupport), push("batteryMode", batteryModeLabel(powerOptions.batteryMode), powerOptions.batteryMode), push("batteryCapacityMah", `${value(powerOptions.batteryCapacityMah)} mAh`, powerOptions.batteryCapacityMah), push("flickerFree", formatBoolean(value(t.flickerFree)), t.flickerFree), known(t.coolingType)&&rows.push(Object.freeze({
        key:"cooling", labelTr:FIELD_LABELS.cooling, valueTr:coolingLabel(t.coolingType, t.fanRpm, t.quietCapability), sourceStatus:t.coolingType.status, confidence:Math.min(t.coolingType.confidence??0, known(t.fanRpm)?t.fanRpm.confidence??0:1)
      }
      )), known(t.quietCapability)&&rows.push(Object.freeze({
        key:"quietCapability", labelTr:FIELD_LABELS.quietCapability, valueTr:formatBoolean(value(t.quietCapability)), sourceStatus:t.quietCapability.status, confidence:t.quietCapability.confidence??0
      }
      )), Object.freeze(rows)
    }
    function purposeResult(scoreRow, purposeKey){
      return scoreRow?.purposes?.find(p=>p.purposeKey===purposeKey)||null
    }
    function fpCriterionComment(row){
      if(!row?.applicable)return"Bu satın alma kulvarında uygulanmaz.";
      if(!row.available||!Number.isFinite(row.score))return"Doğrulanmış veri olmadığı için puana zorla katılmadı.";
      if(row.score>=80)return"Bu ölçütte güçlü teknik değer sunuyor.";
      if(row.score>=65)return"Bu ölçütte dengeli bir değer sunuyor.";
      return"Bu ölçüt sınırlı; toplam karar diğer kriterlerle birlikte verilmelidir."
    }
    function admissionLabelTr(state){
      const key=String(state||'').toUpperCase();
      return ({
        PASS:'Öneriye Uygun',
        PASS_WITH_CAUTION:'Uygun · Dikkat Noktası Var',
        EVIDENCE_HOLD:'Veri Doğrulaması Gerekli',
        BLOCK:'Bu Amaç İçin Uygun Değil',
        FAIL:'Bu Amaç İçin Uygun Değil',
        UNKNOWN:'Veri Yetersiz'
      })[key]||'Veri Yetersiz'
    }
    function scoreEvidenceTr(coverage,confidence,min,max){
      const cov=Number(coverage),conf=Number(confidence),lo=Number(min),hi=Number(max),parts=[];
      if(Number.isFinite(cov))parts.push(`kanıt kapsamı %${Math.round(cov*100)}`);
      if(Number.isFinite(conf))parts.push(`güven %${Math.round(conf*100)}`);
      if(Number.isFinite(lo)&&Number.isFinite(hi)&&Math.round(lo)!==Math.round(hi))parts.push(`olası aralık ${Math.round(lo)}–${Math.round(hi)}`);
      return parts.join(' · ')
    }
    const REQUIREMENT_LABELS=Object.freeze({
      battery:'batarya desteği',batteryBundleReadiness:'batarya / şarj paketi',
      goboProjectionOpticReadiness:'projeksiyon / gobo optiği',goboProjectionCompatibility:'projeksiyon / gobo uyumluluğu',
      'setup.goboOptic':'projeksiyon / gobo optiği',modifier:'ışık şekillendirici uyumu','setup.modifier':'ışık şekillendirici uyumu',
      modifierPackageReadiness:'ışık şekillendirici paketi',mountAdapterCompatibility:'bağlantı / adaptör uyumu',
      noise:'sessizlik / fan davranışı',power:'güç gerekliliği',cri:'renk doğruluğu',rgb:'RGB kabiliyeti'
    });
    function requirementLabelTr(key){
      const raw=String(key||'');
      return REQUIREMENT_LABELS[raw]||raw.replace(/^setup\./,'').replace(/([a-z])([A-Z])/g,'$1 $2').replace(/_/g,' ').toLocaleLowerCase('tr-TR')
    }
    function buildAdmissionSummary(purposeKey,lane){
      const catalog=services.catalog.getCatalog(),scores=scoreByOffer();
      if(!catalog||!purposeKey||!['BARE_LIGHT','SINGLE_READY_SET'].includes(lane))return null;
      const rows=catalog.offers.filter(offer=>offer.eligibility?.catalogVisible?.status==='PASS'&&value(offer.purchaseLane)===lane)
        .map(offer=>toPoolItem(offer,scores.get(offer.offerKey),purposeKey));
      const eligible=rows.filter(x=>x.r4sRankAdmissible===true),holds=rows.filter(x=>x.r4sAdmissionState==='EVIDENCE_HOLD'),blocks=rows.filter(x=>x.r4sAdmissionState==='BLOCK');
      const counter=new Map();
      rows.forEach(item=>[...(item.r4sUnknownRequired||[]),...(item.r4sFalseRequired||[])].forEach(key=>counter.set(key,(counter.get(key)||0)+1)));
      const reasons=[...counter.entries()].sort((a,b)=>b[1]-a[1]||String(a[0]).localeCompare(String(b[0]),'tr')).slice(0,3)
        .map(([key,count])=>Object.freeze({key,labelTr:requirementLabelTr(key),count}));
      const otherLane=lane==='BARE_LIGHT'?'SINGLE_READY_SET':'BARE_LIGHT';
      const otherEligible=catalog.offers.filter(offer=>offer.eligibility?.catalogVisible?.status==='PASS'&&value(offer.purchaseLane)===otherLane)
        .map(offer=>toPoolItem(offer,scores.get(offer.offerKey),purposeKey)).filter(x=>x.r4sRankAdmissible===true).length;
      let copyTr='';
      if(!eligible.length){
        const labels=reasons.map(x=>x.labelTr);
        if(labels.some(x=>/batarya/i.test(x)))copyTr='Bu kulvarda doğrulanmış batarya gerekliliğini karşılayan teklif bulunamadı.';
        else if(labels.some(x=>/gobo|projeksiyon/i.test(x)))copyTr='Bu kulvarda doğrulanmış projeksiyon / gobo optiği gerekliliğini karşılayan teklif bulunamadı.';
        else if(labels.some(x=>/şekillendirici|modifier/i.test(x)))copyTr='Bu kulvarda gerekli ışık şekillendirici uyumu doğrulanan teklif bulunamadı.';
        else copyTr='Bu kulvardaki teklifler seçilen amacın zorunlu teknik doğrulama kapılarını geçemedi.';
        if(otherEligible>0)copyTr+=` Diğer satın alma kulvarında ${otherEligible} uygun teklif bulunuyor.`;
      }
      return Object.freeze({purposeKey,lane,total:rows.length,eligibleCount:eligible.length,holdCount:holds.length,blockCount:blocks.length,
        reasons:Object.freeze(reasons),otherLane,otherEligibleCount:otherEligible,copyTr})
    }

    function buildWhyPresentation(item, purpose, reasons){
      const highlights=(item.generalFpCriteria14||[]).filter(row=>row?.applicable&&row.available&&Number.isFinite(row.score)).slice()
        .sort((a,b)=>(Number(b.weightedContribution)||0)-(Number(a.weightedContribution)||0)||a.order-b.order).slice(0,4)
        .map(row=>Object.freeze({criterionKey:row.criterionKey,labelTr:row.labelTr,score:Math.round(row.score),weight:Number(row.weight)||0,commentTr:fpCriterionComment(row)}));
      const strongest=reasons[0]||null,role=purpose?.roleCompatibility||null;
      const strongestLabel=strongest?role?.components?.find(component=>component.key===strongest.key)?.labelTr||strongest.key:"doğrulanmış teknik uygunluk";
      const purposeLabel=purpose?.purposeLabel||"Seçili kullanım amacı",cautionIds=[...(purpose?.cautionGateIds||[])];
      const cautionMap={"G-QUIET-CAUTION":"Sessizlik/fan verisi doğrulanmadı; mikrofonlu ve uzun kayıtlarda kısa bir ses testi yapın.",
        "G-WIDE-CCT-CAUTION":"Geniş CCT aralığı doğrulanmadı; ortamın Kelvin ihtiyacını ürün sayfasından kontrol edin.",
        "G-MODIFIER-CAUTION":"Işık şekillendirici uyumu tam doğrulanmadı; bağlantı ve paket içeriğini kontrol edin."};
      const cautionTr=cautionIds.length?cautionIds.map(id=>cautionMap[id]||"Seçili kullanım için gerekli bir teknik veri doğrulanmadı; güncel ürün bilgisini kontrol edin.").join(" ")
        :item.lane==="BARE_LIGHT"?"Bu teklif yalnız ışık ünitesidir; gerekli ayak ve ışık şekillendirici paket dışında olabilir.":"Canlı fiyat ile doğrulanmış paket içeriğini satın alma öncesinde birlikte kontrol edin.";
      const usageProfile=Object.freeze([
        Object.freeze({labelTr:"Seçilen amaç",valueTr:purposeLabel}),Object.freeze({labelTr:"Satın alma biçimi",valueTr:item.laneLabelTr}),
        Object.freeze({labelTr:"Önerilen ışık rolü",valueTr:role?.labelTr||"Rol verisi kanıt bekliyor"})
      ]);
      return Object.freeze({
        purposeLabelTr:purposeLabel,
        scoreExplanations:Object.freeze([
          Object.freeze({key:"purpose",labelTr:"Amaç Uyumu",value:Number.isFinite(item.purposeScore)?Math.round(item.purposeScore):null,
            explanationTr:`Kafa Teknik Uyumu ile Setup Hazırlığını seçili amaçta ilan edilmiş setup ağırlığı (%${Math.round(Number(item.setupReadinessWeight)||0)}) üzerinden birleştiren ana Scenario Fit puanıdır.`}),
          Object.freeze({key:"head",labelTr:"Kafa Teknik Uyumu",value:Number.isFinite(item.headPurposeFitScore)?Math.round(item.headPurposeFitScore):null,
            explanationTr:`Yalnız ışık kafasının teknik uygunluğunu ölçer; paket içeriği H puanını değiştirmez.${scoreEvidenceTr(item.headPurposeFitCoverage,item.headPurposeFitConfidence,item.headPurposeFitMin,item.headPurposeFitMax)?' '+scoreEvidenceTr(item.headPurposeFitCoverage,item.headPurposeFitConfidence,item.headPurposeFitMin,item.headPurposeFitMax)+'.':''}`}),
          Object.freeze({key:"setup",labelTr:"Setup Hazırlığı",value:Number.isFinite(item.setupReadinessScore)?Math.round(item.setupReadinessScore):null,
            explanationTr:`Modifier, stand, adaptör, güç ve ilgili paket gereklilikleri bakımından kuruluma hazırlığı gösterir.${scoreEvidenceTr(item.setupReadinessCoverage,item.setupReadinessConfidence,item.setupReadinessMin,item.setupReadinessMax)?' '+scoreEvidenceTr(item.setupReadinessCoverage,item.setupReadinessConfidence,item.setupReadinessMin,item.setupReadinessMax)+'.':''}`}),
          Object.freeze({key:"fp",labelTr:"Genel F/P",value:Number.isFinite(item.generalFpScore)?Math.round(item.generalFpScore):null,
            explanationTr:"Canlı fiyata karşı teknik ve paket değerini sabit kalibrasyonla aynı 14 kriter üzerinden ölçer."}),
          Object.freeze({key:"role",labelTr:"Rol Uyumu",value:Number.isFinite(item.roleCompatibilityScore)?Math.round(item.roleCompatibilityScore):null,
            explanationTr:`${role?.labelTr||"Önerilen ışık rolü"} için yardımcı görev uygunluğudur; R4S sıralamasını değiştirmez.`})
        ]),
        fpHighlights:Object.freeze(highlights),usageProfile,
        strengthTr:strongest?`${strongestLabel}: ${Math.round(strongest.score)}/100 ile teknik kafa değerlendirmesinde öne çıkan doğrulanmış alandır.`:"Doğrulanmış teknik alanlar birlikte değerlendirilmiştir.",
        cautionTr,
        noraExpertTr:`${item.title}, ${purposeLabel.toLocaleLowerCase("tr-TR")} için Amaç Uyumu ${Number.isFinite(item.purposeScore)?Math.round(item.purposeScore)+'/100':'—'}, Kafa Teknik Uyumu ${Number.isFinite(item.headPurposeFitScore)?Math.round(item.headPurposeFitScore)+'/100':'—'} ve Setup Hazırlığı ${Number.isFinite(item.setupReadinessScore)?Math.round(item.setupReadinessScore)+'/100':'—'} ile değerlendirilmiştir. Genel F/P ${Number.isFinite(item.generalFpScore)?Math.round(item.generalFpScore)+'/100':'—'}; Rol Uyumu yardımcı bilgidir ve sıralamayı etkilemez.`,
        admissionLabelTr:admissionLabelTr(item.r4sAdmissionState||item.purposeGateState),criterionCount:14,owner:"R4S-S6-C3-SCORE-SEMANTICS-V1"
      })
    }

    function fpEligibilityMeta(offer, general){
      const criteria=[...(general?.criteria14||[])];
      const applicable=criteria.filter(row=>row.applicable!==false);
      const available=applicable.filter(row=>row.available===true);
      const coverage=Number(general?.scoreCoverage);
      const confidence=Number(general?.scoreConfidence);
      const priceMinor=Number(value(offer?.priceMinor));
      const coverageThreshold=Number(services.config?.thresholds?.generalFpCoverage??0.55);
      const confidenceThreshold=Number(services.config?.thresholds?.generalFpConfidence??0.60);
      const reasons=[];

      if(offer?.eligibility?.catalogVisible?.status!=="PASS")reasons.push("CATALOG_NOT_VISIBLE");
      if(!Number.isFinite(Number(general?.benefitScore)))reasons.push("NO_AGGREGATE");
      if(!Number.isFinite(coverage)||coverage<coverageThreshold)reasons.push("COVERAGE_BELOW_THRESHOLD");
      if(!Number.isFinite(confidence)||confidence<confidenceThreshold)reasons.push("CONFIDENCE_BELOW_THRESHOLD");
      if(!Number.isFinite(priceMinor)||priceMinor<=0)reasons.push("PRICE_MISSING");

      const parts=[];
      if(reasons.includes("NO_AGGREGATE"))parts.push("uygulanabilir F/P kanıtı oluşmadı");
      if(reasons.includes("COVERAGE_BELOW_THRESHOLD")){
        const actual=Number.isFinite(coverage)?Math.round(coverage*100):0;
        parts.push(`veri kapsamı %${actual} / gereken %${Math.round(coverageThreshold*100)}`);
      }
      if(reasons.includes("CONFIDENCE_BELOW_THRESHOLD")){
        const actual=Number.isFinite(confidence)?Math.round(confidence*100):0;
        parts.push(`kanıt güveni %${actual} / gereken %${Math.round(confidenceThreshold*100)}`);
      }
      if(reasons.includes("PRICE_MISSING"))parts.push("canlı fiyat doğrulanmadı");
      if(reasons.includes("CATALOG_NOT_VISIBLE"))parts.push("ürün müşteri havuzunda görünür değil");

      return Object.freeze({
        eligible:Boolean(general?.eligible),
        coverage:Number.isFinite(coverage)?coverage:null,
        confidence:Number.isFinite(confidence)?confidence:null,
        coverageThreshold,
        confidenceThreshold,
        applicableCriterionCount:applicable.length,
        availableCriterionCount:available.length,
        unavailableCriterionKeys:Object.freeze(applicable.filter(row=>row.available!==true).map(row=>row.criterionKey)),
        reasonCodes:Object.freeze(reasons),
        reasonTr:Boolean(general?.eligible)
          ?"Genel F/P hesaplandı."
          :`Genel F/P hesaplanmadı${parts.length?`: ${parts.join("; ")}.`:"."}`
      });
    }

    function toPoolItem(offer, scoreRow, purposeKey){
      const shadowRow=r4sShadowByOffer().get(offer.offerKey)||null;
      const r4s=r4sPurposeResult(shadowRow,purposeKey);
      const general=scoreRow?.generalFp||null,legacyPurpose=purposeResult(scoreRow,purposeKey);
      const compareStatus=offer.eligibility?.comparisonEligible?.status||"FAIL",images=imageList(offer),pkg=packageItems(offer),technical=technicalRows(offer),variant=value(offer.selectedVariant)||{};
      const commerceEligible=value(offer.available)!==false&&variant.available!==false&&!!variant.id;
      const fpStable=shadowRow?.stableGeneralFp||null,fpMeta=fpEligibilityMeta(offer,fpStable||general);
      const admission=r4s?.admission||'EVIDENCE_HOLD';
      return Object.freeze({
        offerKey:offer.offerKey,title:services.narrative.publicTitle(value(offer.title)||offer.offerKey,offer),url:value(offer.url)||`/products/${offer.offerKey}`,
        image:images[0]||null,images,priceMinor:value(offer.priceMinor),compareAtPriceMinor:value(offer.compareAtPriceMinor),available:value(offer.available)!==false,
        variantId:variant.id?String(variant.id):null,variantTitle:variant.title||"",variantAvailable:variant.available!==false,commerceEligible,
        commerceDisabledReasonTr:commerceEligible?"":variant.id?"Bu ürün şu anda stokta değil.":"Satın alınabilir varyant bulunamadı.",
        lane:value(offer.purchaseLane),laneLabelTr:laneLabel(value(offer.purchaseLane)),headFamilyKey:value(offer.headFamilyKey),

        purposeScore:r4s?.scenarioFit??null,scenarioFit:r4s?.scenarioFit??null,scenarioFitMin:r4s?.scenarioFitMin??null,scenarioFitMax:r4s?.scenarioFitMax??null,
        headPurposeFitScore:r4s?.headPurposeFit?.score??null,headPurposeFitMin:r4s?.headPurposeFit?.min??null,headPurposeFitMax:r4s?.headPurposeFit?.max??null,
        headPurposeFitCoverage:r4s?.headPurposeFit?.coverage??null,headPurposeFitConfidence:r4s?.headPurposeFit?.confidence??null,
        setupReadinessScore:r4s?.setupReadiness?.score??null,setupReadinessMin:r4s?.setupReadiness?.min??null,setupReadinessMax:r4s?.setupReadiness?.max??null,
        setupReadinessCoverage:r4s?.setupReadiness?.coverage??null,setupReadinessConfidence:r4s?.setupReadiness?.confidence??null,
        setupReadinessWeight:r4s?.setupReadinessWeight??0,
        r4sAdmissionState:admission,r4sRankAdmissible:['PASS','PASS_WITH_CAUTION'].includes(admission),
        r4sFalseRequired:Object.freeze([...(r4s?.requiredAdmission?.falseRequired||[]),...(r4s?.falseHardSetupRequirements||[])]),
        r4sUnknownRequired:Object.freeze([...(r4s?.requiredAdmission?.unknownRequired||[]),...(r4s?.unknownHardSetupRequirements||[])]),

        generalFpRawScore:fpStable?.generalFpStableRaw??null,generalFpScore:fpStable?.generalFpCalibrated??null,fpCalibrationVersion:fpStable?.calibrationVersion||null,
        generalFpCalibration:fpStable?Object.freeze({method:'R4S_FROZEN_ANCHOR_PLUS_FIXED_SIGMOID',version:fpStable.calibrationVersion||null}):null,
        generalFpEligible:!!fpStable?.eligible,generalFpCoverage:fpMeta.coverage,generalFpConfidence:fpMeta.confidence,
        generalFpCoverageThreshold:fpMeta.coverageThreshold,generalFpConfidenceThreshold:fpMeta.confidenceThreshold,
        generalFpAvailableCriterionCount:fpMeta.availableCriterionCount,generalFpApplicableCriterionCount:fpMeta.applicableCriterionCount,
        generalFpUnavailableCriterionKeys:fpMeta.unavailableCriterionKeys,generalFpUnavailableReasonCodes:fpMeta.reasonCodes,
        generalFpUnavailableReasonTr:fpStable?.eligible?"Genel F/P hesaplandı.":fpMeta.reasonTr,
        generalFpCriteria14:Object.freeze([...(fpStable?.criteria14||general?.criteria14||legacyPurpose?.generalFpCriteria14||[])]),generalFpCriterionCount:14,

        roleCompatibilityScore:legacyPurpose?.roleCompatibilityScore??null,roleCompatibility:legacyPurpose?.roleCompatibility||null,roleCompatibilityRankingInfluence:"NONE",
        scoreContractVersion:"R4S-S4-CANONICAL-DECISION-V1",purposeGateState:admission,purposeRankingEligible:['PASS','PASS_WITH_CAUTION'].includes(admission),
        legacyPurposeScore:legacyPurpose?.purposeScore??null,legacyGeneralFpScore:legacyPurpose?.generalFpScore??null,
        catalogStatus:offer.eligibility?.catalogVisible?.status||"FAIL",comparisonStatus:compareStatus,comparisonEligible:compareStatus==="PASS",
        comparisonDisabledReasonTr:compareStatus==="PASS"?"":"Karşılaştırma için yeterli ve çelişkisiz teknik veri bulunmuyor.",
        packageItems:Object.freeze(pkg),technicalRows:technical,
        searchText:fold([value(offer.title),value(offer.vendor),value(offer.productType),value(offer.headFamilyKey),value(offer.tags)?.join?.(" "),laneLabel(value(offer.purchaseLane))].join(" "))
      });
    }

    function buildPool(options={}){
      const catalog=services.catalog.getCatalog();
      if(!catalog)return Object.freeze({items:Object.freeze([]),total:0,filtered:0,query:"",lane:"ALL",sort:"PURPOSE",purposeKey:""});
      const scores=scoreByOffer(),purposeKey=String(options.purposeKey||""),query=fold(options.query||""),lane=options.lane||"ALL",sort=options.sort||"PURPOSE";
      let all=catalog.offers.filter(offer=>offer.eligibility?.catalogVisible?.status==="PASS"&&["BARE_LIGHT","SINGLE_READY_SET"].includes(value(offer.purchaseLane))).map(offer=>toPoolItem(offer,scores.get(offer.offerKey),purposeKey));
      const catalogVisibleTotal=all.length;
      let items=purposeKey?all.filter(item=>item.r4sRankAdmissible===true):all;
      const total=items.length;
      if(lane!=="ALL")items=items.filter(item=>item.lane===lane);
      if(query)items=items.filter(item=>item.searchText.includes(query));

      if(sort==="PURPOSE"&&purposeKey){
        const comparator=services.recommender?._test?.r4sComparator;
        const scoreCandidate=services.recommender?._test?.r4sScoreCandidate;
        const shadowRows=r4sShadowByOffer();
        const candidateFor=item=>{
          const offer=catalogOffer(item.offerKey),legacyOffer=scores.get(item.offerKey),legacyPurpose=purposeResult(legacyOffer,purposeKey);
          const shadowOffer=shadowRows.get(item.offerKey),shadowPurpose=r4sPurposeResult(shadowOffer,purposeKey),purposeDef=services.scoring.getPurposeDefinition?.(purposeKey);
          return typeof scoreCandidate==='function'?scoreCandidate(shadowOffer,shadowPurpose,legacyOffer,legacyPurpose,purposeDef,offer):null
        };
        const mapped=items.map(item=>({item,candidate:candidateFor(item)})).filter(x=>x.candidate);
        if(typeof comparator==='function')mapped.sort((a,b)=>comparator(a.candidate,b.candidate));
        items=mapped.map(x=>x.item);
      }else{
        const n=(v,f=-1)=>Number.isFinite(Number(v))?Number(v):f;
        const sorters={
          GENERAL_FP:(a,b)=>n(b.generalFpScore)-n(a.generalFpScore)||a.title.localeCompare(b.title,"tr"),
          PRICE_LOW:(a,b)=>n(a.priceMinor,Number.MAX_SAFE_INTEGER)-n(b.priceMinor,Number.MAX_SAFE_INTEGER)||a.title.localeCompare(b.title,"tr"),
          PRICE_HIGH:(a,b)=>n(b.priceMinor)-n(a.priceMinor)||a.title.localeCompare(b.title,"tr"),
          TITLE:(a,b)=>a.title.localeCompare(b.title,"tr")
        };
        items.sort(sorters[sort]||sorters.TITLE);
      }
      const result=Object.freeze({
        items:Object.freeze(items),total,filtered:items.length,catalogVisibleTotal,excludedByR4SAdmission:purposeKey?catalogVisibleTotal-total:0,
        query:options.query||"",lane,sort,purposeKey,rankingPolicyVersion:purposeKey?'COB-V5-R4S-S4-CANONICAL-RANKING-POLICY-V1':'NONE'
      });
      state.lastPool=result;diagnostics.productPool={total,filtered:items.length,catalogVisibleTotal,lane,sort,purposeKey};return result;
    }

    function getDetail(offerKey, purposeKey=""){
      const offer=catalogOffer(offerKey);
      if(!offer)return null;
      const score=scoreByOffer().get(offer.offerKey), item=toPoolItem(offer, score, purposeKey), p=purposeResult(score, purposeKey), rawSetup=purposeKey?services.setup.get(purposeKey):null, setup=rawSetup?Object.freeze({
        ...rawSetup, publicSetupSummaryTr:services.narrative.publicSetupSummary(rawSetup)
      }
      ):null, reasons=(p?.factorDetails||[]).slice().sort((a, b)=>b.score*b.weight-a.score*a.weight).slice(0, 3).map(x=>({
        key:x.key, score:x.score, weight:x.weight
      }
      ));
      return Object.freeze({
        ...item, bodyText:value(offer.bodyText)||"", vendor:value(offer.vendor)||"", productType:value(offer.productType)||"", purposeResult:p, setup, reasons:Object.freeze(reasons), evidenceNoteTr:evidenceSummary(p, item.technicalRows), whyPresentation:buildWhyPresentation(item,p,reasons)
      }
      )
    }
    function selected(){
      return Object.freeze([...state.compareKeys])
    }
    function emitChanged(source="api"){
      const detail={
        keys:selected(), count:state.compareKeys.length, source
      }
      ;
      return diagnostics.comparison={
        count:detail.count, keys:detail.keys
      }
      , events.emit("comparison:changed", detail), detail
    }
    function toggleCompare(offerKey, source="api"){
      const key=services.schema.normalizedHandle(offerKey), offer=catalogOffer(key);
      if(!offer)return Object.freeze({
        ok:!1, code:"NOT_FOUND", keys:selected()
      }
      );
      if(offer.eligibility?.comparisonEligible?.status!=="PASS")return Object.freeze({
        ok:!1, code:"NOT_ELIGIBLE", messageTr:"Bu \xFCr\xFCn kar\u015F\u0131la\u015Ft\u0131rma i\xE7in yeterli do\u011Frulanm\u0131\u015F veriye sahip de\u011Fil.", keys:selected()
      }
      );
      const at=state.compareKeys.indexOf(key);
      return at>=0?(state.compareKeys.splice(at, 1), Object.freeze({
        ok:!0, code:"REMOVED",...emitChanged(source)
      }
      )):state.compareKeys.length>=3?(events.emit("comparison:limit", {
        limit:3, offerKey:key
      }
      ), Object.freeze({
        ok:!1, code:"LIMIT", messageTr:"Ayn\u0131 anda en fazla \xFC\xE7 \xFCr\xFCn kar\u015F\u0131la\u015Ft\u0131r\u0131labilir.", keys:selected()
      }
      )):(state.compareKeys.push(key), Object.freeze({
        ok:!0, code:"ADDED",...emitChanged(source)
      }
      ))
    }
    function removeCompare(key, source="api"){
      const normalized=services.schema.normalizedHandle(key), at=state.compareKeys.indexOf(normalized);
      return at<0?!1:(state.compareKeys.splice(at, 1), emitChanged(source), !0)
    }
    function clearCompare(source="api"){
      return state.compareKeys.length?(state.compareKeys=[], emitChanged(source), !0):!1
    }
    function compareCustomerValue(raw){
      let text=String(raw??"").replace(/\s+/g," ").trim();
      if(!text||/^Bilinmiyor$/i.test(text)||/^Veri yok$/i.test(text))return"Belirtilmemiş";

      text=text
        .replace(/^ölçüm konfigürasyonu\s*:/i,"Ölçüm koşulu:")
        .replace(/\bpuan dışı\b/gi,"yalnız bilgi amaçlı")
        .replace(/\s*·\s*0\s*K(?=\s*·|$)/gi,"")
        .replace(/\s+/g," ")
        .replace(/\s*·\s*·\s*/g," · ")
        .trim();

      return text||"Belirtilmemiş"
    }
    function compareValue(detail, key){
      const raw=detail.technicalRows.find(x=>x.key===key||key==="cctRange"&&x.key==="cctRange")?.valueTr;
      return compareCustomerValue(raw)
    }
    function purposePriorityTechnicalKeys(purposeKey){
      const p=services.scoring.getPurposeDefinition?.(purposeKey)||null;
      if(!p)return Object.freeze([]);
      const w=p.weights||{};
      const keys=[];
      const add=(...items)=>items.forEach(key=>{if(!keys.includes(key))keys.push(key)});
      if(Number(w.usableOutput||0)>=10)add('powerW','photometricOutput');
      if(Number(w.colorAccuracy||0)>=10)add('cri','tlci');
      if(Number(w.cctFlexibility||0)>=8)add('cctRange');
      if(Number(w.rgbCreativeCapability||0)>=10)add('colorFamily','fxModeCount');
      if(Number(w.quietFlickerThermalStability||0)>=8)add('quietCapability','flickerFree','cooling');
      if(Number(w.controlWorkflow||0)>=8)add('dmx','bluetooth','appControl','remote2_4g');
      if(Number(w.portabilityPowerAutonomy||0)>=8)add('batterySupport','batteryMode','batteryCapacityMah');
      if(Number(w.lightQualityShaping||0)>=10)add('mountType');
      return Object.freeze(keys);
    }

    function comparisonRankCandidate(detail,purposeKey){
      if(!detail||detail.comparisonEligible!==true)return null;
      const offer=catalogOffer(detail.offerKey),legacyOffer=scoreByOffer().get(detail.offerKey)||null;
      const legacyPurpose=(legacyOffer?.purposes||[]).find(row=>row.purposeKey===purposeKey)||null;
      const shadowOffer=r4sShadowByOffer().get(detail.offerKey)||null,shadowPurpose=r4sPurposeResult(shadowOffer,purposeKey);
      const purposeDef=services.scoring.getPurposeDefinition?.(purposeKey)||null,scoreCandidate=services.recommender?._test?.r4sScoreCandidate;
      if(!offer||!legacyOffer||!legacyPurpose||!shadowOffer||!shadowPurpose||!purposeDef||!(Number(offer?.priceMinor?.value)>0)||typeof scoreCandidate!=='function')return null;
      const candidate=scoreCandidate(shadowOffer,shadowPurpose,legacyOffer,legacyPurpose,purposeDef,offer);
      return candidate?.rankingEligible===true?candidate:null;
    }
    function canonicalComparisonOrder(details,purposeKey){
      const source=Object.freeze([...(details||[])]),laneSet=new Set(source.map(item=>item?.lane).filter(Boolean)),crossLane=laneSet.size>1;
      if(crossLane)return Object.freeze({items:source,candidates:Object.freeze([]),crossLane:true,sameLane:false,canonicalOrderReady:false,rankAdmissible:false,source:'CROSS_LANE_SELECTION_ORDER_PRESERVED',reasonCode:'CROSS_LANE_NO_COMMON_RANK'});
      if(laneSet.size!==1)return Object.freeze({items:source,candidates:Object.freeze([]),crossLane:false,sameLane:false,canonicalOrderReady:false,rankAdmissible:false,source:'LANE_CONTEXT_INCOMPLETE',reasonCode:'LANE_CONTEXT_INCOMPLETE'});
      const recommenderTest=services.recommender?._test||null;
      if(typeof recommenderTest?.r4sScoreCandidate!=='function'||typeof recommenderTest?.r4sComparator!=='function')return Object.freeze({items:source,candidates:Object.freeze([]),crossLane:false,sameLane:true,canonicalOrderReady:false,rankAdmissible:false,source:'R4S_RECOMMENDER_TEST_API_UNAVAILABLE',reasonCode:'R4S_RECOMMENDER_TEST_API_UNAVAILABLE'});
      const mapped=source.map(detail=>Object.freeze({detail,candidate:comparisonRankCandidate(detail,purposeKey)}));
      if(mapped.some(row=>!row.candidate))return Object.freeze({items:source,candidates:Object.freeze(mapped.map(row=>row.candidate)),crossLane:false,sameLane:true,canonicalOrderReady:false,rankAdmissible:false,source:'SAME_LANE_SELECTION_ORDER_PRESERVED',reasonCode:'R4S_ADMISSION_INCOMPLETE'});
      mapped.sort((a,b)=>recommenderTest.r4sComparator(a.candidate,b.candidate));
      return Object.freeze({items:Object.freeze(mapped.map(row=>row.detail)),candidates:Object.freeze(mapped.map(row=>row.candidate)),crossLane:false,sameLane:true,canonicalOrderReady:true,rankAdmissible:true,source:'R4S_RECOMMENDER_COMPARATOR',reasonCode:'R4S_CANONICAL_ORDER'});
    }

    function comparisonRankReason(candidates){
      if(!Array.isArray(candidates)||candidates.length<2)return 'Tek ürün için karşılaştırma sırası oluşturulmadı.';
      const a=candidates[0],b=candidates[1];
      if(a.publicScenarioBand!==b.publicScenarioBand)return `Amaç Uyumu ${a.publicScenarioBand} > ${b.publicScenarioBand}.`;
      if(a.publicHeadBand!==b.publicHeadBand)return `Amaç Uyumu bandı eşit; Kafa Teknik Uyumu ${a.publicHeadBand} > ${b.publicHeadBand}.`;
      if(a.publicGeneralFpBand!==b.publicGeneralFpBand)return `Amaç ve kafa uyumu eşit; Genel F/P ${a.publicGeneralFpBand} > ${b.publicGeneralFpBand}.`;
      return 'Görünür karar ölçüleri eşit; R4S ham karar girdileri ve yalnız tam eşitlikte deterministik kanıt/ürün anahtarı sırası kullanılır.';
    }

    function buildComparisonDecision(orderInfo,purposeKey){
      const items=orderInfo?.items||[];if(items.length<2)return null;
      if(orderInfo.crossLane===true)return Object.freeze({
        version:'COB-V5-R4S-S4-COMPARISON-DECISION-V1',owner:'PRODUCT_EXPERIENCE_R4S_CANONICAL_DECISION',
        canonicalOrderReady:false,crossLane:true,rankAdmissible:false,leaderOfferKey:null,leaderTitle:null,noraTier:null,noraTierLabelTr:'',noraRole:'compareDecision',
        titleTr:'NORA · Kulvarlar farklı',reasonCode:'CROSS_LANE_NO_COMMON_RANK',
        copyTr:'Yalnız ışık ve hazır set farklı satın alma biçimleridir. Bu nedenle ortak kazanan veya ortak sıra gösterilmez; seçtiğiniz ürünlerin kolon sırası korunur. Amaç Uyumu, Kafa Teknik Uyumu, Setup Hazırlığı, Genel F/P, canlı fiyat ve paket içeriğini birlikte değerlendirin.'
      });
      if(orderInfo.canonicalOrderReady!==true)return Object.freeze({
        version:'COB-V5-R4S-S4-COMPARISON-DECISION-V1',owner:'PRODUCT_EXPERIENCE_R4S_CANONICAL_DECISION',
        canonicalOrderReady:false,crossLane:false,rankAdmissible:false,leaderOfferKey:null,leaderTitle:null,noraTier:null,noraTierLabelTr:'',noraRole:'honestCaution',
        titleTr:'NORA · Ortak sıra gösterilmiyor',reasonCode:orderInfo.reasonCode||'R4S_ORDER_UNAVAILABLE',
        copyTr:'Seçili ürünlerden en az biri bu amaç için R4S kabul kapısından geçmedi. Teknik alanları karşılaştırabilirsiniz; ancak ortak kazanan veya olumlu sıralama gösterilmez.'
      });
      const leader=items[0],profile=services.capabilities?.getProfile?.(leader.offerKey)||null,nora=services.noraDecisionPolicy?.resolveDetail?.(leader,{purposeKey,profile,rank:null})||null;
      const orderTr=items.map((item,index)=>`${index+1}. ${item.title}`).join(' → '),reason=comparisonRankReason(orderInfo.candidates);
      return Object.freeze({
        version:'COB-V5-R4S-S4-COMPARISON-DECISION-V1',owner:'PRODUCT_EXPERIENCE_R4S_CANONICAL_DECISION',
        canonicalOrderReady:true,crossLane:false,rankAdmissible:true,leaderOfferKey:leader.offerKey,leaderTitle:leader.title,
        noraTier:nora?.tier||null,noraTierLabelTr:nora?.tierLabelTr||'',noraRole:'compareDecision',titleTr:nora?.titleTr||'NORA karar özeti',
        reasonCode:'R4S_CANONICAL_ORDER',copyTr:`${leader.title} bu karşılaştırmada ilk sırada. Sıralama: ${orderTr}. ${reason} Bu sıra yalnız karşılaştırdığınız ürünler içindir; Rol Uyumu sıralamayı etkilemez.`
      });
    }

    function buildFp14Rows(details){
      const registry=[...(services.scoring.getRegistry?.()?.criteria||[])];
      const fallback=[...(details[0]?.generalFpCriteria14||[])];
      const seed=(registry.length===14?registry:fallback).slice().sort((a,b)=>Number(a.order||0)-Number(b.order||0));
      return Object.freeze(seed.map(baseRow=>Object.freeze({
        order:Number(baseRow.order)||0,
        criterionKey:baseRow.criterionKey,
        labelTr:baseRow.labelTr||baseRow.criterionKey,
        values:Object.freeze(details.map(item=>{
          const row=(item.generalFpCriteria14||[]).find(candidate=>candidate.criterionKey===baseRow.criterionKey)||null;
          const publicScore=row?.applicable===true&&row?.available===true&&Number.isFinite(Number(row?.score))
            ?Math.round(Number(row.score))
            :null;
          return Object.freeze({
            offerKey:item.offerKey,
            title:item.title,
            applicable:row?.applicable===true,
            available:row?.available===true,
            score:publicScore,
            confidence:Number.isFinite(Number(row?.confidence))?Number(row.confidence):null
          });
        }))
      })));
    }
    function buildFp14DifferenceRows(rows){
      return Object.freeze((rows||[]).map(row=>{
        const numeric=row.values
          .filter(value=>value.applicable===true&&value.available===true&&Number.isFinite(Number(value.score)))
          .map(value=>Math.round(Number(value.score)));
        const delta=numeric.length>=2?Math.max(...numeric)-Math.min(...numeric):0;
        return Object.freeze({row,delta,numericCount:numeric.length});
      }).filter(entry=>entry.numericCount>=2&&entry.delta>=1)
        .sort((a,b)=>b.delta-a.delta||a.row.order-b.row.order)
        .map(entry=>Object.freeze({
          order:entry.row.order,criterionKey:entry.row.criterionKey,labelTr:entry.row.labelTr,
          delta:entry.delta,values:entry.row.values
        })));
    }
    function buildComparisonFromDetails(inputDetails,purposeKey=''){
      const rawDetails=(inputDetails||[]).filter(Boolean);
      if(rawDetails.length<2)return Object.freeze({
        ready:false,items:Object.freeze(rawDetails),rows:Object.freeze([]),messageTr:'Karşılaştırmak için en az iki ürün seçin.'
      });
      const selectionOrderOfferKeys=Object.freeze(rawDetails.map(item=>item.offerKey));
      const orderInfo=canonicalComparisonOrder(rawDetails,purposeKey);
      const details=[...orderInfo.items];
      const crossLane=orderInfo.crossLane===true;
      const allTechnicalKeys=['powerW','photometricOutput','colorFamily','cctRange','cri','tlci','mountType','fxModeCount','warrantyYears','dmx','bluetooth','appControl','remote2_4g','batterySupport','batteryMode','batteryCapacityMah','flickerFree','cooling','quietCapability'];
      const priorityKeys=[...purposePriorityTechnicalKeys(purposeKey)].filter(key=>allTechnicalKeys.includes(key));
      const orderedTechnicalKeys=[...priorityKeys,...allTechnicalKeys.filter(key=>!priorityKeys.includes(key))];
      const rawRows=[
        ['lane','Satın alma biçimi',details.map(x=>x.laneLabelTr),'SUMMARY'],
        ['price','Canlı satış fiyatı',details.map(x=>x.priceMinor),'SUMMARY'],
        ['availability','Stok',details.map(x=>x.available?'Stokta':'Stokta değil'),'SUMMARY'],
        ['purposeScore','Amaç Uyumu',details.map(x=>Number.isFinite(x.purposeScore)?Math.round(x.purposeScore):'Belirtilmemiş'),'SUMMARY'],
        ['headPurposeFit','Kafa Teknik Uyumu',details.map(x=>Number.isFinite(x.headPurposeFitScore)?Math.round(x.headPurposeFitScore):'Belirtilmemiş'),'SUMMARY'],
        ['setupReadiness','Setup Hazırlığı',details.map(x=>Number.isFinite(x.setupReadinessScore)?Math.round(x.setupReadinessScore):'Belirtilmemiş'),'SUMMARY'],
        ['generalFp','Genel F/P',details.map(x=>crossLane?'Kulvarlar farklı':Number.isFinite(x.generalFpScore)?Math.round(x.generalFpScore):'Belirtilmemiş'),'SUMMARY'],
        ['admission','Karar durumu',details.map(x=>admissionLabelTr(x.r4sAdmissionState||x.purposeGateState||'UNKNOWN')),'SUMMARY'],
        ['roleCompatibility','Önerilen Rol Uyumu',details.map(x=>Number.isFinite(x.roleCompatibilityScore)?Math.round(x.roleCompatibilityScore):'Belirtilmemiş'),'SUMMARY'],
        ...orderedTechnicalKeys.map(key=>[
          key,
          FIELD_LABELS[key]||(key==='cctRange'?'CCT aralığı':key),
          details.map(x=>compareValue(x,key)),
          priorityKeys.includes(key)?'PURPOSE_CRITICAL':'DETAIL'
        ]),
        ['package','Doğrulanmış paket içeriği',details.map(x=>x.packageItems.length?x.packageItems.join(', '):x.lane==='BARE_LIGHT'?'Yalnız ışık ünitesi':'Açık paket verisi yok'),'PACKAGE']
      ];
      const rows=rawRows.map(([key,labelTr,values,group])=>Object.freeze({
        key,labelTr,group,priority:group==='PURPOSE_CRITICAL',values:Object.freeze(values)
      }));
      const fp14Rows=buildFp14Rows(details);
      const fp14DifferenceRows=buildFp14DifferenceRows(fp14Rows);
      const decision=buildComparisonDecision(orderInfo,purposeKey);
      const warningTr=crossLane
        ?'Ürünler farklı satın alma kulvarlarında. Ortak R4S sıra/kazanan üretilmez ve seçim sırası korunur.'
        :orderInfo.canonicalOrderReady!==true
          ?'Seçili aynı-kulvar ürünlerin tamamı R4S admission kapısından geçmediği için ortak sıra/kazanan üretilmedi.'
          :'';
      return Object.freeze({
        ready:true,
        items:Object.freeze(details),
        rows:Object.freeze(rows),
        priorityTechnicalKeys:Object.freeze(priorityKeys),
        comparisonPolicyVersion:'COB-V5-R4S-S4-COMPARISON-DECISION-V1',
        fp14:Object.freeze(details.map(item=>Object.freeze({offerKey:item.offerKey,criteria:Object.freeze([...(item.generalFpCriteria14||[])])}))),
        fp14Rows,
        fp14DifferenceRows,
        fp14DifferenceCount:fp14DifferenceRows.length,
        fp14PublicPrecision:0,
        fp14MeaningfulDeltaMin:1,
        scoreContract:services.scoring.getScoreContract?.()||null,
        crossLane,
        rankAdmissible:orderInfo.rankAdmissible===true,
        canonicalOrderReady:orderInfo.canonicalOrderReady===true,
        canonicalOrderSource:orderInfo.source,
        canonicalOrderReasonCode:orderInfo.reasonCode,
        selectionOrderOfferKeys,
        displayOrderOfferKeys:Object.freeze(details.map(item=>item.offerKey)),
        selectionOrderPreserved:crossLane?selectionOrderOfferKeys.every((key,index)=>details[index]?.offerKey===key):orderInfo.canonicalOrderReady!==true?selectionOrderOfferKeys.every((key,index)=>details[index]?.offerKey===key):false,
        decision,
        warningTr
      });
    }
    function buildComparison(purposeKey=""){
      const details=state.compareKeys.map(key=>getDetail(key,purposeKey)).filter(Boolean);
      return buildComparisonFromDetails(details,purposeKey);
    }

    function init(){
      state.listeners.push(events.on("catalog:building", ()=>clearCompare("catalog-rebuild")))
    }
    function destroy(){
      state.listeners.splice(0).forEach(x=>x()), state.compareKeys=[], state.lastPool=null
    }
    return Object.freeze({
      init, destroy, buildPool, getDetail, toggleCompare, removeCompare, clearCompare, getSelected:selected, buildComparison, buildAdmissionSummary, admissionLabelTr, getLastPool:()=>state.lastPool, getScoreContract:()=>services.scoring.getScoreContract?.()||null, _test:Object.freeze({
        fold, modifierTypeLabel, packageItems, recordDisplay, mountLabel, batteryModeLabel, coolingLabel, photometricRow, evidenceSummary, technicalRows, toPoolItem, fpCriterionComment, buildWhyPresentation, purposePriorityTechnicalKeys, fpEligibilityMeta, admissionLabelTr, scoreEvidenceTr, requirementLabelTr, buildAdmissionSummary, r4sShadowByOffer, r4sPurposeResult, comparisonRankCandidate, canonicalComparisonOrder, comparisonRankReason, buildComparisonDecision, buildFp14Rows, buildFp14DifferenceRows, buildComparisonFromDetails
      }
      )
    }
    )
  }
  )

  window.GDX_COB_V5_FAZ0963_PHOTOMETRIC_PRESENTATION=Object.freeze({
    loaded:true,
    version:'COB-V5-FAZ09.6.3-PHOTOMETRIC-LUX-PRESENTATION-V1',
    scoringMutation:'NONE',
    rankingMutation:'NONE',
    evidenceMutation:'NONE',
    setupTruthMutation:'NONE',
    commerceMutation:'NONE'
  });

  window.debugCobV5Faz0963PhotometricLuxPresentationQaV1=function(){
    const service=app?.runtime?.get?.('productExperience');
    const catalog=app?.runtime?.get?.('catalog')?.getCatalog?.();
    const offers=(catalog?.offers||[]).filter(offer=>service?._test?.photometricRow?.(offer));
    const rows=offers.map(offer=>({
      offerKey:offer.offerKey,
      headFamilyKey:offer.headFamilyKey?.value??offer.headFamilyKey,
      row:service._test.photometricRow(offer)
    }));
    const longRawDump=rows.filter(item=>(item.row?.valueTr.match(/\bLux\b/g)||[]).length>4);
    const checks={
      markerLoaded:window.GDX_COB_V5_FAZ0963_PHOTOMETRIC_PRESENTATION?.loaded===true,
      servicePresent:!!service,
      photometricOffersFound:rows.length>0,
      groupedPresentation:rows.every(item=>(item.row.presentationGroupCount||0)<=Math.max(1,item.row.rawPhotometricRowCount||0)),
      noLongRawCctDump:longRawDump.length===0,
      labelUsesLuxNotLumen:rows.every(item=>item.row.labelTr==='Aydınlık düzeyi / Lux'),
      scoringMutationNone:true,
      rankingMutationNone:true,
      evidenceMutationNone:true,
      setupTruthMutationNone:true,
      commerceMutationNone:true
    };
    const failedChecks=Object.keys(checks).filter(k=>!checks[k]);
    const out={
      ok:failedChecks.length===0,
      version:'COB-V5-FAZ09.6.3-PHOTOMETRIC-LUX-PRESENTATION-QA-V1',
      checks,failedChecks,
      sample:rows.slice(0,5).map(item=>({offerKey:item.offerKey,headFamilyKey:item.headFamilyKey,valueTr:item.row.valueTr,rawCount:item.row.rawPhotometricRowCount,groupCount:item.row.presentationGroupCount})),
      scoringMutation:'NONE',
      rankingMutation:'NONE',
      evidenceMutation:'NONE',
      setupTruthMutation:'NONE',
      commerceMutation:'NONE'
    };
    console.log(out);return out
  };

}
)();
  window.GDX_COB_V5_R4S_S4_PRODUCT_EXPERIENCE=Object.freeze({
    loaded:true,version:'COB-V5-R4S-S4-PRODUCT-EXPERIENCE-V1',
    poolOwner:'R4S_ADMISSION_PLUS_RECOMMENDER_COMPARATOR',comparisonOwner:'R4S_RECOMMENDER_COMPARATOR',
    crossLaneWinnerPolicy:'NONE',roleRankingInfluence:'NONE'
  });

  window.GDX_COB_V5_R4S_S6_C3_PRODUCT_EXPERIENCE=Object.freeze({
    loaded:true,version:'COB-V5-R4S-S6-C3-PRODUCT-EXPERIENCE-V1',
    fp14Owner:'R4S_STABLE_GENERAL_FP',admissionPresentation:'CUSTOMER_LABELS',
    zeroResultReasonOwner:'R4S_REQUIRED_ADMISSION_AGGREGATE',scoringMutation:'NONE',rankingMutation:'NONE'
  });

